export default __webpack_public_path__ + "static/media/reset.151d38e2.png";